<div class="px-4 pt-5 my-5 text-center ">
  <h1 class="display-4 fw-bold " style="color: var(--primary-color)">Servicios</h1>
  <div class="col-lg-6 mx-auto">
    <p class="lead mb-4 text-secondary ">Te presentamos nuestra amplia gama de servicios diseñados pensando en ti, para que siempre te sientas cuidado y acompañado. Tú nos importas y queremos que sepas que estamos aquí para ofrecerte soluciones integrales y de calidad, porque en Medilink cuidamos de ti como te mereces.</p>
    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
    </div>
  </div>
</div>
